
import React from 'react';
import SaasSignupFormContainer from './saas/signup/SaasSignupFormContainer';
import { SaasSignupFormValues } from '@/schemas/saasSignupSchema';

interface SaasSignupFormProps {
  onSubmit: (data: SaasSignupFormValues & { captcha: string }) => void;
  isLoading: boolean;
}

const SaasSignupForm = ({ onSubmit, isLoading }: SaasSignupFormProps) => {
  return (
    <SaasSignupFormContainer 
      onSubmit={onSubmit}
      isLoading={isLoading}
    />
  );
};

export default SaasSignupForm;
